import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ClassNotebookLogoInverse16Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M0 1824V224L1152 0v2048L0 1824zM177 540v968l201 11v-314q0-156-1-314l366 648 232 13V495l-225 13v639l-3-6q-2-4-14-23t-32-57-61-106-99-172-146-255l-218 12zm1775 228q16 0 33 5t31 15 23 24 9 33v230q0 19-9 33t-22 24-31 15-34 5h-32V768h32zm0 512q16 0 33 5t31 15 23 24 9 33v230q0 19-9 33t-22 24-31 15-34 5h-32v-384h32zm-416-768v128h-128V512h128zm512-179v230q0 19-9 33t-22 24-31 15-34 5h-160v1152q0 26-10 49t-27 41-41 28-50 10h-384v-384h256v-128h-256v-128h256v-128h-256V576q0 30 9 58t26 52 40 42 53 28v268h128V756q28-10 52-28t40-41 26-52 10-59q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75V128h384q26 0 49 10t41 27 28 41 10 50h160q16 0 33 5t31 15 23 24 9 33z" />
    </svg>
  ),
  displayName: 'ClassNotebookLogoInverse16Icon',
});

export default ClassNotebookLogoInverse16Icon;
